import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daij7fboh653ivfvoe70";

type Status = "idle" | "submitting" | "success" | "error";

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const guard = String(formData.get("website_alt") || "").trim();
    if (guard) {
      setStatus("success");
      setMessage("订阅成功，感谢关注。");
      form.reset();
      return;
    }

    const email = String(formData.get("email") || "").trim();
    if (!email) {
      setStatus("error");
      setMessage("请填写有效的邮箱地址。");
      return;
    }

    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      params.append(key, String(value));
    });

    setStatus("submitting");
    setMessage("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message ||
        parsed?.message ||
        parsed?.meta?.detail ||
        responseText ||
        "";
      const isSpam = /spam/i.test(serverMsg);
      const okCode = parsed?.code === "OK";

      if (response.ok && okCode && !isSpam) {
        setStatus("success");
        setMessage("订阅成功，我们会在每期专题整理完成后发送汇总。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，提交未成功，请稍后重试。");
    }
  };

  return (
    <form data-readdy-form onSubmit={handleSubmit} className="w-full" noValidate>
      <div className="flex flex-col sm:flex-row gap-3">
        <label className="sr-only" htmlFor="subscribe-email">
          邮箱地址
        </label>
        <input
          id="subscribe-email"
          type="email"
          name="email"
          required
          placeholder="填写邮箱，订阅每期更新汇总"
          className="flex-1 px-4 py-3 rounded-md text-sm bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/30"
        />
        <button
          type="submit"
          disabled={status === "submitting"}
          className="px-6 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer bg-primary-500 text-background-950 hover:bg-primary-400 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
        >
          {status === "submitting" ? "提交中..." : "订阅"}
        </button>
      </div>

      <input
        className="subscribe-guard"
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      {status !== "idle" && status !== "submitting" && (
        <p
          className={`mt-3 text-xs ${
            status === "success" ? "text-secondary-300" : "text-accent-300"
          }`}
          role="status"
        >
          {message}
        </p>
      )}
      <p className="mt-3 text-xs text-foreground-500">
        仅用于发送栏目更新与勘误通知，不会用于其他用途。
      </p>
    </form>
  );
}